import PropTypes from 'prop-types';
import React from 'react';
import { Box, Copy, Icon, IconWrapper, Link } from '@honda-canada/design-system-react';

import themeStyles from './DealerContact.style';
import { pushGtmDealerCardInfo } from '../../../utils/gtmTags';

const ContactWrapper = themeStyles.apply(Box, 'ContactWrapper');
const ContactLink = themeStyles.apply(Link, 'ContactLink');
const ContactFax = themeStyles.apply(Copy, 'ContactFax');

const DealerContactDetail = ({ contact, prefix, type, gtmTags, gtmActionType, dealer }) => {
  if (!contact || !type) {
    return null;
  }

  const attributes = {
    testid: `cy-${type}-detail`,
  };

  if (prefix) {
    attributes.href = `${prefix}:${contact}`;
  } else if (type === 'website') {
    attributes.href = `http://${contact}`;
    attributes.target = '_blank';
  }

  const handlePushGtmDealerInfo = () => {
    pushGtmDealerCardInfo(gtmActionType, dealer?.name, dealer?.code);
  };

  return (
    <ContactWrapper>
      <IconWrapper data-testid={`cy-${type}-icon`}>
        <Icon name={type} />
      </IconWrapper>
      {type === 'fax' ? (
        <ContactFax size="small" data-testid={attributes.testid}>
          {contact}
        </ContactFax>
      ) : (
        <Box onClick={handlePushGtmDealerInfo} maxWidth="100%">
          <ContactLink {...gtmTags} {...attributes} linkColor="red" data-testid={attributes.testid} styling="primary">
            {contact}
          </ContactLink>
        </Box>
      )}
    </ContactWrapper>
  );
};

DealerContactDetail.propTypes = {
  contact: PropTypes.string,
  prefix: PropTypes.string,
  type: PropTypes.oneOf(['phone', 'website', 'fax', 'email']).isRequired,
  gtmTags: PropTypes.shape({
    'data-gtm-interaction-type': PropTypes.string,
    'data-gtm-title': PropTypes.string,
    'data-gtm-component-type': PropTypes.string,
  }),
  gtmActionType: PropTypes.string,
  dealer: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
  }),
};

export default DealerContactDetail;
